<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">Refactoring & Security Updates</h1>
                            <p class="lead">
                                Legacy Code modernisieren, Sicherheitslücken schließen – PHP, Vue.js, JavaScript & TypeScript
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <h2>Warum Code Refactoring?</h2>
                                <p>
                                    Über die Jahre wächst jede Codebasis. Features werden hinzugefügt, 
                                    Anforderungen ändern sich, und verschiedene Entwickler hinterlassen ihre Spuren. 
                                    Das Ergebnis: <strong>Legacy Code</strong>, der schwer zu warten, zu erweitern 
                                    und zu verstehen ist.
                                </p>
                                <p>
                                    Professionelles Refactoring verbessert die <strong>Code-Qualität</strong>, 
                                    ohne die Funktionalität zu ändern. Das Resultat: schnellere Entwicklung, 
                                    weniger Bugs und zufriedenere Entwickler.
                                </p>

                                <div class="alert alert-danger mt-4">
                                    <strong>⚠️ Sicherheitswarnung:</strong> Durch den Einsatz von KI-Tools werden 
                                    täglich neue Sicherheitslücken in veralteter Software entdeckt. Was früher Jahre 
                                    dauerte, passiert jetzt in Stunden. <strong>Software-Updates sind nicht mehr 
                                    "nice to have" – sie sind essentiell!</strong>
                                </div>

                                <div class="alert alert-warning mt-3">
                                    <strong>Technische Schulden?</strong> Je länger Sie warten, desto teurer wird 
                                    die Modernisierung. Wir helfen Ihnen, Ihre Codebasis schrittweise zu verbessern.
                                </div>

                                <h3 class="mt-5">Unsere Refactoring-Expertise</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <i class="ni ni-settings mr-2"></i>
                                                    PHP Refactoring
                                                </h5>
                                                <p>
                                                    Migration zu PHP 8.x, PSR-Standards, Composer-Integration, 
                                                    Framework-Updates (Laravel, Symfony).
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <i class="ni ni-app mr-2"></i>
                                                    Vue.js Refactoring
                                                </h5>
                                                <p>
                                                    Migration Vue 2 → Vue 3, Composition API, TypeScript-Integration, 
                                                    Pinia State Management.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <i class="ni ni-html5 mr-2"></i>
                                                    JavaScript Modernisierung
                                                </h5>
                                                <p>
                                                    ES6+ Migration, jQuery-Ablösung, moderne Build-Tools, 
                                                    Code-Splitting und Tree Shaking.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-atom" class="mr-2"></icon>
                                                    TypeScript Migration
                                                </h5>
                                                <p>
                                                    Schrittweise TypeScript-Einführung, Type-Safety, 
                                                    bessere IDE-Unterstützung und Fehlerprävention.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">Security Updates & Vulnerability Fixes</h3>
                                <p>
                                    Mit dem Aufkommen von KI-gestützten Sicherheitstools werden täglich 
                                    hunderte neue Schwachstellen in bestehender Software entdeckt. 
                                    <strong>Veraltete Abhängigkeiten sind das größte Einfallstor für Angreifer.</strong>
                                </p>
                                <div class="row mt-4">
                                    <div class="col-md-6">
                                        <div class="p-3 bg-gradient-danger text-white rounded mb-3">
                                            <h5 class="text-white"><i class="ni ni-lock-circle-open mr-2"></i>Risiken veralteter Software</h5>
                                            <ul class="mb-0">
                                                <li>Bekannte CVEs (Common Vulnerabilities)</li>
                                                <li>SQL Injection, XSS, CSRF</li>
                                                <li>Veraltete Verschlüsselung</li>
                                                <li>Unsichere Dependencies</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="p-3 bg-gradient-success text-white rounded mb-3">
                                            <h5 class="text-white"><i class="ni ni-lock-circle-open mr-2"></i>Unsere Security-Maßnahmen</h5>
                                            <ul class="mb-0">
                                                <li>Dependency Audits (npm, Composer)</li>
                                                <li>Automatisierte Security Scans</li>
                                                <li>Patch Management</li>
                                                <li>Penetration Testing</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <h3 class="mt-5">Unser Refactoring-Ansatz</h3>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Code-Analyse</strong> – Statische Analyse, Code-Metriken, Abhängigkeiten
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Test-Abdeckung</strong> – Bestehende Tests prüfen, fehlende Tests ergänzen
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Schrittweise Migration</strong> – Kleine, sichere Änderungen statt Big Bang
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Design Patterns</strong> – SOLID-Prinzipien, Clean Architecture
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Dokumentation</strong> – Code-Kommentare, API-Docs, Architektur-Diagramme
                                    </li>
                                </ul>

                                <h3 class="mt-5">Typische Refactoring-Szenarien</h3>
                                <div class="row mt-4">
                                    <div class="col-md-6">
                                        <h5 class="text-muted">Vorher</h5>
                                        <ul>
                                            <li>Monolithische Architektur</li>
                                            <li>Veraltete PHP-Version (5.x, 7.x)</li>
                                            <li>jQuery-Spaghetti-Code</li>
                                            <li>Keine Tests vorhanden</li>
                                            <li>Unklare Abhängigkeiten</li>
                                            <li>Lange Deployment-Zeiten</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <h5 class="text-success">Nachher</h5>
                                        <ul>
                                            <li>Modulare Architektur</li>
                                            <li>PHP 8.x mit Type Hints</li>
                                            <li>Modernes Vue.js/React</li>
                                            <li>Automatisierte Tests (80%+)</li>
                                            <li>Klare Dependency Injection</li>
                                            <li>CI/CD Pipeline</li>
                                        </ul>
                                    </div>
                                </div>

                                <h3 class="mt-5">Technologien & Tools</h3>
                                <div class="mt-3">
                                    <h6 class="text-muted">PHP</h6>
                                    <badge type="primary" rounded class="mr-2 mb-2">PHP 8.x</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Laravel</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Symfony</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">PHPStan</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Rector</badge>
                                    
                                    <h6 class="text-muted mt-3">JavaScript/TypeScript</h6>
                                    <badge type="success" rounded class="mr-2 mb-2">Vue.js 3</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">React</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">TypeScript</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">ESLint</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">Vite</badge>
                                    
                                    <h6 class="text-muted mt-3">Testing</h6>
                                    <badge type="warning" rounded class="mr-2 mb-2">PHPUnit</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Jest</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Vitest</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Cypress</badge>
                                </div>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="warning"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Kostenlose Code-Analyse anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'refactoring',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'Refactoring & Security Updates',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'Refactoring & Security Updates DACH ✓ Sicherheitslücken schließen ✓ PHP 8 Migration ✓ Vue.js Upgrade ✓ Dependency Updates ✓ CVE Fixes ✓ Jetzt Audit anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'Code Refactoring, Security Updates, Sicherheitslücken, PHP Refactoring, Vue.js Migration, Dependency Updates, CVE, Software Sicherheit, Legacy Code, PHP 8 Migration'
            },
            {
                property: 'og:title',
                content: 'Code Refactoring PHP, Vue.js, JavaScript | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'Professionelles Code Refactoring. PHP 8 Migration, Vue.js 2→3 Upgrade, JavaScript Modernisierung, TypeScript Migration. Legacy Code modernisieren.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/refactoring'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'Code Refactoring PHP, Vue.js, JavaScript | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'PHP 8 Migration, Vue.js 2→3 Upgrade, JavaScript Modernisierung, TypeScript Migration.'
            }
        ]
    }
}
</script>
